import { RovoAgentAri } from '@atlassian/ari';
import { type Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import type { BrowseCategory } from '../../types.ts';

type AgentGql = {
	id: string;
	name?: string | null;
	description?: string | null;
	isFavourite?: boolean | null;
	deactivated?: boolean | null;
	creatorType?: string | null;
	conversationStarters?: readonly string[] | null;
	identityAccountId?: string | null;
	externalConfigReference?: string | null;
	creator?: {
		id: string;
	} | null;
	icon?: string | null;
	authoringTeam?: {
		id?: string | null;
		profileUrl?: string | null;
		displayName?: string | null;
		smallAvatarImageUrl?: string | null;
	} | null;
	forgeCreator?: string | null;
};

/**
 * @deprecated DO NOT USE: useFragment and relay instead!!
 */
export const mapAgentGqlToAgent = (agent: AgentGql): Agent => {
	return {
		id: RovoAgentAri.parse(agent.id).agentId,
		name: agent.name ?? '',
		named_id: RovoAgentAri.parse(agent.id).agentId,
		actor_type: 'AGENT',
		available_plugins: {},
		creator_type: (agent.creatorType ?? 'CUSTOMER') as Agent['creator_type'],
		description: agent.description ?? null,
		favourite: agent.isFavourite ?? false,
		deactivated: agent.deactivated ?? false,
		user_defined_conversation_starters: agent.conversationStarters?.slice() ?? [],
		is_default: false,
		agentAri: agent.id,
		creator: agent.forgeCreator ?? agent.creator?.id,
		identity_account_id: agent.identityAccountId,
		external_config_reference: agent.externalConfigReference ?? undefined,
		authoring_team: agent.authoringTeam
			? {
					id: agent.authoringTeam.id ?? '',
					profile_url: agent.authoringTeam.profileUrl ?? '',
					display_name: agent.authoringTeam.displayName ?? '',
					avatar_url: agent.authoringTeam.smallAvatarImageUrl ?? undefined,
				}
			: undefined,
		icon: agent.icon ?? undefined,
	};
};

type PaginationQueryInput = {
	name?: string | null | undefined;
	onlyEditableAgents?: boolean | null | undefined;
	onlyFavouriteAgents?: boolean | null | undefined;
	onlyMyAgents?: boolean | null | undefined;
	onlyTemplateAgents?: boolean | null | undefined;
	onlyVerifiedAgents?: boolean | null | undefined;
};

export const getPaginationQueryInput = ({
	tab,
	searchValue,
}: {
	tab: BrowseCategory;
	searchValue: string;
}): PaginationQueryInput | undefined => {
	const input: PaginationQueryInput = {};

	if (searchValue.trim()) {
		input.name = searchValue.trim();
	}

	switch (tab) {
		case 'my-agents':
			input.onlyMyAgents = true;
			break;
		case 'starred-agents':
			input.onlyFavouriteAgents = true;
			break;
		case 'templates':
			input.onlyTemplateAgents = true;
			break;
		case 'verified-agents':
			input.onlyVerifiedAgents = true;
			break;
	}

	return Object.keys(input).length > 0 ? input : undefined;
};
